import React,{useEffect,useState} from "react";
import Modal from "react-bootstrap/Modal";
import YouTube from 'react-youtube';
import Helper from '../functions/Helper.js'
import SizeScale from '../components/SizeScale.jsx';

const ratingTextStyle={
  textAlign:"center",
  borderRadius:2,
  width: 50,
  height: 35,
  display:"flex",
  alignItems:"center",
  justifyContent:"center",
  fontWeight: 'bold',
  color: 'white',
  fontSize:16
};

const RatingText=({rating,category})=>{
    if(category==="outdoor"){
      return(
        <div style={{
          ...ratingTextStyle,backgroundColor:Helper.get_color(rating,"outdoor")}}>
          {Helper.getOutdoorDescription(rating)}
        </div>
      );
    }

    if(category==="size" || category==="width"  ){
      return(
        <div style={{  textAlign:"center",
          ...ratingTextStyle,
          color: 'white',lineHeight:"14px",fontSize:12,backgroundColor:"grey"}}>
          {Helper.getSizeDescription(rating,category,"short")}
        </div>
      );
    }

    else{
      return(
        <div style={{  textAlign:"center",
          ...ratingTextStyle,
          fontSize:18,backgroundColor:Helper.get_color(rating)}}>
          {Helper.roundto(rating,1)}
        </div>
      );
    }
  }


export default function ExpertReviewPopup(props){
  return(
    <Modal onHide={()=>props.hide()} show={!!props.review}>
      <Modal.Header closeButton>
        <Modal.Title>{props.review.shoe_name}</Modal.Title>
      </Modal.Header>
      <Modal.Body>

        <div style={{marginTop:-20}}>
          {(props.review.type==="video" || props.review.type==="both")  &&
            <div style={{paddingBottom:30}}>
              <YouTube containerClassName={"youtubeContainer"} opts={{playerVars: { autoplay:0}}} videoId={Helper.getVideoID(props.review?.video_url ?? "","videoID")}/>
            </div>
          }
          {(props.review.type==="blog" || props.review.type==="both")  &&
            <div style={{paddingBottom:30,fontSize:16}}>
              <span style={{fontWeight:600}}>Blog URL: </span><a style={{fontWeight:600}} href={props.review.blog_url}>{props.review.blog_url}</a>
            </div>
          }
        </div>

      <div style={{display:"flex",alignItems:"center"}}>
        <RatingText rating={props.review.rating} category="rating"/>
        <div style={{marginLeft:10,fontWeight:600,fontSize:20}}>Overall Rating </div>
      </div>
      <div style={{fontSize:16,marginTop:10,marginBottom:20,}}>
        {props.review.overall_quote}
      </div>

      <div style={{marginBottom:props.review.width ==="-1" ? 15: 10 ,display:"flex",alignItems:"flex-end",fontSize:16}}>
        <div style={{flex:0,fontWeight:600,flexBasis:70,lineHeight:1}}>Sizing:</div>
        {props.review.size==="-1" ?
          <div style={{lineHeight:1,paddingLeft:20,fontWeight:600,color:"#555",}}>NA</div>:
          <div  style={{justifyContent:"flex-end",textAlign:"right",display:"flex",flex:2,paddingLeft:20}}>
            <SizeScale shoe_name={props.review.shoe_name} percent={props.review.size} type="size"/>
          </div>
        }
      </div>


      <div style={{marginBottom:60,display:"flex",alignItems:"flex-end",fontSize:16}}>
        <div style={{flex:0,fontWeight:600,flexBasis:70,lineHeight:1}}>Width:</div>
        {props.review.width ==="-1" ?
          <div style={{lineHeight:1,paddingLeft:20,fontWeight:600,color:"#555",}}>NA</div>:
          <div style={{justifyContent:"flex-end",textAlign:"right",display:"flex",flex:2,paddingLeft:20}}>
            <SizeScale shoe_name={props.review.shoe_name} percent={props.review.width} type="width"/>
          </div>
        }
      </div>

      {["traction","cushion","materials","support","fit","outdoor","width","size"].map((category)=>
        {
          if(props.review[category]!=="-1"){
            return(
              <div key={category} style={{marginTop:40}}>
                <div style={{display:"flex",alignItems:"center"}}>
                  <RatingText rating={props.review[category]} category={category}/>
                  <div style={{marginLeft:10,fontWeight:600,fontSize:16}}>{Helper.capitalize(category)}</div>
                </div>
                <div style={{fontSize:15,marginTop:5}}>
                  {props.review[category +"_quote"]}
                </div>
              </div>
            )
          }
          else{
            return(null)
          }
        }
      )}
      </Modal.Body>
    </Modal>
  );
}
